const MLS_PURCHASE_PARAMS = ["open_mls_purchase", "mls_purchase"]

/**
 * Owners whose trial ended are sent to /candidates from most pages, but they
 * must still be able to buy MLS (from a purchase link) and land back on My MLS
 * after the Zoho checkout.
 */
export function isMlsPurchaseFlow(pathname, search) {
  if (!pathname.startsWith("/leads")) return false
  const params = new URLSearchParams(search || "")
  return MLS_PURCHASE_PARAMS.some((key) => params.has(key))
}
